import React from 'react';

function WorkerEarningsPage() {
    return (
        <div>
            <h1 className="text-3xl font-bold text-gray-800 mb-6">My Earnings</h1>
            <div className="bg-white p-6 rounded-lg shadow-md">
                <p>This page will display a detailed breakdown of your earnings from completed jobs, payout history, and options for withdrawal.</p>
                <div className="mt-8">
                    <h3 className="text-xl font-semibold">Summary</h3>
                    <p className="font-mono text-lg mt-2">Total Earned: ৳15,500</p>
                    <p className="font-mono text-lg">Withdrawn: ৳10,000</p>
                    <p className="font-mono text-lg font-bold">Available for Payout: ৳5,500</p>
                    <button className="mt-4 bg-green-600 text-white font-bold py-2 px-4 rounded hover:bg-green-700">
                        Request Payout
                    </button>
                </div>
            </div>
        </div>
    );
}

export default WorkerEarningsPage;
